import { useSpring, animated } from "react-spring";
import MobilePortalTable from "../../components/MobilePortal/MobilePortalTable";
import { useGetDepartmentListWithPaginationQuery } from "../../app/services/departments";
import { useEffect, useState } from "react";
import { ColumnFiltersState, PaginationState } from "@tanstack/react-table";
import { toast, ToastContainer } from "react-toastify";
import CreatePopupNameTextLogo from "../../components/ProjectStatusPopup/CreatePopupNameTextLogo";
import { useCreatePortalLinkMutation, useGetPortalDataQuery, useUpdatePortalLinkMutation } from "../../app/services/landing";
import Button from "../../components/common/Button";
import { endpointUrl } from "../../app/services/api";
import axios from "../../axios";
import { getAuthUser } from "../../app/services/dashboard";
import CreatePopupNameAndText from "../../components/ProjectStatusPopup/CreatePopupNameAndText";
import CommonErrorPopup from "../../components/common/CommonErrorPopup";
const mobile_portal_links = [
    {
        id: 1,
        key: 'roster',
        name_en: 'Roster',
        name_tc: 'Roster',
        name_sc: 'Roster',
        logo: '',
        link: ''
    }
]
const MobilePortalPage = () => {

    const props = useSpring({
        to: { opacity: 1 },
        from: { opacity: 0 },
        delay: 1000,
    });
    const [data, setData] = useState<any[]>([]);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [isLayoutControlOpen, setIsLayoutControlOpen] =
        useState<boolean>(false);
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [isEditing, setIsEdit] = useState<boolean>(false);
    const [isSubmit, setIsSubmit] = useState<boolean>(false);
    const [editedData, setEditData] = useState<any>("");
    const [isOpenPopup, setIsOpenPopup] = useState<boolean>(false);
    const [uploading, setUploading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    const [isError, setIsError] = useState<boolean>(false);
    const { data: landingData } = useGetPortalDataQuery();
    useEffect(() => {
        if (landingData) {
            setData(landingData);
        }
    }, [landingData]);
    const save_portal_data = (saveData: any, formData: any) => {
        formData.append('parent_id', saveData.parent_id ?? 5);
        formData.append('key', saveData.key ?? saveData.name_en?.replace(' ', '-'));
        formData.append('name_en', saveData.name_en??'');
        formData.append('name_tc', saveData.name_tc??'');
        formData.append('name_sc', saveData.name_sc??'');
        formData.append('link_en', saveData.link_en??'');
        formData.append('link_tc', saveData.link_tc ? saveData.link_tc??'' : saveData.link_en??'');
        formData.append('link_sc', saveData.link_sc ? saveData.link_sc??'' : saveData.link_en??'');
        if(saveData.id){
            formData.append('id', saveData.id?.toString());
        }
        formData.append('order', saveData.order);
        if (saveData.logo) {
            formData.append('logo', saveData.logo);
        }
    }
    const createPortalData = async (data: any) => {
        const formData = new FormData();
        save_portal_data(data, formData)
        var getUser = getAuthUser();
        await axios(endpointUrl + "mobile-portal-links", {
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${getUser.token}`,
            },
            data: formData,
        })
            .then((payload: any) => {
                setEditData("");
                toast("Successfully Saved.", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    type: "success",
                    theme: "light",
                });

                setIsSubmit(false);
                setUploading(false);
                setData((prev) => [
                    ...prev,
                    {

                        id: payload?.data?.data?.id,
                        name_en: payload?.data?.data?.name_en,
                        name_tc: payload?.data?.data?.name_tc,
                        name_sc: payload?.data?.data?.name_sc,
                        link_en: payload?.data?.data?.link_en,
                        link_tc: payload?.data?.data?.link_tc,
                        link_sc: payload?.data?.data?.link_sc,
                        logo: payload?.data?.data?.logo,
                        order: payload?.data?.data?.order,
                        parent_id: payload?.data?.data?.parent_id,
                    }
                ]);
                setIsOpenPopup(false);
            })
            .catch((error) => {
                setIsError(true);
                setError(error?.data?.message);
                setIsSubmit(false);
                setUploading(false);
                setIsOpenPopup(false);
            });
    };
    const updatePortalData = async (data: any) => {
        const formData = new FormData();
        save_portal_data(data, formData);
        formData.append('_method', 'PUT');
        var getUser = getAuthUser();
        await axios(endpointUrl + "mobile-portal-links/" + data.id, {
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${getUser.token}`,
            },
            data: formData,
        })
            .then((payload: any) => {
                setEditData("");
                toast("Successfully Saved.", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    type: "success",
                    theme: "light",
                });

                setIsSubmit(false);
                setUploading(false);
                setData((prev) =>
                    prev.map((item) => {
                        if (item.id === editedData.id) {
                            return {
                                ...item,
                                name_en: payload?.data?.data?.name_en,
                                name_tc: payload?.data?.data?.name_tc,
                                name_sc: payload?.data?.data?.name_sc,
                                link_en: payload?.data?.data?.link_en,
                                link_tc: payload?.data?.data?.link_tc,
                                link_sc: payload?.data?.data?.link_sc,
                                logo: payload?.data?.data?.logo,
                                order: payload?.data?.data?.order,
                                parent_id: payload?.data?.data?.parent_id,
                            };
                        } else {
                            return item;
                        }
                    })
                );
                setIsOpenPopup(false);
            })
            .catch((error) => {
                setIsError(true);
                setError(error?.data?.message);
                setIsSubmit(false);
                setUploading(false);
                setIsOpenPopup(false);
            });
    };
    return <div className="px-2 sm:px-4 py-4 bg-white sm:mt-[25px] mt-0 font-poppins text-13 font-semibold text-[#858795] tracking-[-0.03rem] w-full h-full rounded-xl pt-3 pb-8 sm:pt-3 sm:pb-9">
        <CommonErrorPopup message={error} setMessage={setError} setShow={setIsError} show={isError} />
        <div className="flex items-center justify-end xs:mt-1 sm:mt-1">
            <Button
                label="+ Add New"
                onClick={() => setIsOpenPopup(true)}
                type="button"
                variant="primary"
                customClass="py-[3px] my-1 px-2 focus:outline-none hover:bg-vorpmyanmar hover:border-vorpmyanmar hover:text-vorpblue 2xl:text-[14px] text-12 leading-5 font-medium text-white"
                size="base"
            />
        </div>
        <animated.div>
            <MobilePortalTable
                data={data}
                setData={setData}
                setIsSuccess={setIsSuccess}
                isSuccess={isSuccess}
                pagination={pagination}
                setPagination={setPagination}
                isLayoutControlOpen={isLayoutControlOpen}
                setIsLayoutControlOpen={setIsLayoutControlOpen}
                globalSearch={''}
                setGlobalSearch={() => 1}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                setHiddenFields={1}
                hiddenFields={[]}
                setCurrentView={1}
                setIsEdit={setIsEdit}
                isEditing={isEditing}
                localModuleId={0}
                total={data.length}
                changePage={1}
                setCurrentPage={1}
                currentPage={1}
                setEditData={setEditData}
                setIsOpenPopup={setIsOpenPopup}

            />
        </animated.div>
        <ToastContainer className={"text-12 font-poppins font-normal"} />
        <CreatePopupNameAndText
            isOpen={isOpenPopup}
            setIsOpen={setIsOpenPopup}
            editedData={editedData}
            setEditData={setEditData}
            savePopupData={createPortalData}
            updatePopupData={updatePortalData}
            title="Resource Center"
            isSubmit={isSubmit}
            setIsSubmit={setIsSubmit}
            uploading={uploading}
            setUploading={setUploading}
        />
    </div>
}
export default MobilePortalPage;